import { render, staticRenderFns } from "./NisccReport.vue?vue&type=template&id=524a5595"
import script from "./NisccReport.vue?vue&type=script&lang=js"
export * from "./NisccReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports